import { QueryKey } from '@portal/constants';
import { useInfiniteQuery } from '@tanstack/react-query';
import { findUsers } from '../../../../api/portalServices';
import { SortOrder } from '../../../../api/types';
import { useSession } from '../../../../common/authorization/context/Session';
import { transformSearchPattern, UserFieldNames } from '../userUtils';

export const useUsers = (searchValue: string) => {
  const pattern = transformSearchPattern(searchValue);
  const tenantId = useSession().tenantId;

  return useInfiniteQuery({
    queryKey: [QueryKey.FIND_USERS],
    queryFn: async ({ pageParam }) => {
      if (pageParam === undefined) {
        return { users: [], pagingInfo: { afterToken: pageParam } };
      }
      const payload = {
        pageSize: 100,
        ...(pageParam
          ? { pageToken: pageParam }
          : {
              selectors: {
                search: { pattern, fields: [UserFieldNames.DISPLAY_NAME, UserFieldNames.UPN] },
                sortFields: [{ field: UserFieldNames.DISPLAY_NAME, order: SortOrder.ASC }],
              },
            }),
      };
      return findUsers(tenantId || '', payload);
    },
    initialPageParam: '',
    getNextPageParam: lastPage => {
      if (lastPage.pagingInfo?.afterToken === '') {
        return undefined;
      }
      return lastPage.pagingInfo?.afterToken;
    },
    select: ({ pages }) => pages.flatMap(page => page.users),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
    retry: false,
  });
};
